<template>
  <help-dialog title="Entities">
    <template #default>
      <h3 class="mb-1 text-black">
        <span class="bg-grey-lighten-3">Entities</span>
      </h3>
      <p class="text-grey-darken-3">
        An <b>Entity</b> contains a set of fields or attributes and is often implemented as a database table.
        <br /><br />
        <b>Entities</b> can be connected to other <b>Entities</b>, forming a hierarchy of related data.
        They are used by both <b>Read Models</b> and <b>Commands</b>.
        <br /><br />
        Each <b>Command</b> should have one <b>Entity</b> designated as the <b>Aggregate Root</b>. This serves as
        the primary <b>Entity</b> that a <b>Command</b> operates on.

        <br /><br />
        <b>Read Models</b> can also be linked to <b>Entities</b>, as they retrieve and present data in response to queries.
      </p>
      <br />
      <p class="text-grey-darken-3">
        An <b>Entity</b> contains a set of data fields with example data. The following actions are available for each field:
      </p>
      <ul class="ml-5">
        <li>
          <b>Set as primary key:</b>&nbsp;Marks the field with a key icon (🔑), designating it as the primary key
          for that Entity. Only one field may be set as the primary key at a time.
        </li>
        <li><b>Set as reference:</b>&nbsp;Indicates that the field is a reference to another Entity
          (a foregin key if implemented in a relational database).
        </li>
        <li>
          <b>Set as required/optional:</b>&nbsp;Toggles whether the field is required or not.
        </li>
        <li>
          <b>Generate example data:</b>&nbsp;Uses AI to automatically populate the field with sample values.
          This example data is used in the <b>Data Fields</b> tab in the sidebar to help you preview how forms will look.
        </li>
        <li><b>Delete:</b>&nbsp;Removes the field from the list.</li>
      </ul>
      <br /><br />
      <p class="text-grey-darken-4">
        To read our full guide to Entities and how to use them in your Domain-Driven Design,
        <a
          href="https://www.qlerify.com/domain-driven-design"
          target="_blank"
          class="text-blue-accent-4"
        >
          click here
        </a>.
      </p>
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  }
}
</script>

<style scoped>
.write-model {
  background-color: var(--blue-2);
}
</style>
